<template>
    <div class="searchContent white_bg" style="padding-bottom: 90px;">
        <!-- 导航搜索部分 -->
        <div class="paddingH16 relative white_bg" style="padding-top: 1px; z-index: 5">
            <!-- 搜索部分 -->
            <div class="search flexLayout" style="padding-top: 4px; padding-bottom: 4px; line-height: 36px;">
                <div class="searchBack" style="width: 36px;">
                    <img class="icon position" src="icon/black_left_angle_brackets.svg"
                         style="top: 7px;"
                       @click="$router.replace({name:'index'})"/>
                </div>

                <searchInputbox ref="searchInputbox" @change="onChangeKeywords" @suggest="onSuggest"/>

                <div class="searchBtn colorF55050 alignR f16" style="width: 40px;color:#FFA724;" @click="suggestionList = []; search();">搜索</div>
            </div>

            <div class="suggestion white_bg w100p font14r" v-show="suggestionList.length"
                 style="z-index: 1; left: 0; top: 45px; padding-bottom: 12px;">
                <div class="paddingH12">
                    <div class="paddingV4 bottomBorderEEE" v-for="suggestionItem in suggestionList" :key="suggestionItem.id"
                         @click="onSelectSuggestion(suggestionItem)">
                        <img class="icon size12" src="components/search/grey_magnifier_icon.svg"
                             style="vertical-align:middle"/>
                        {{suggestionItem}}
                    </div>
                </div>
            </div>

            <!-- Tab栏部分 -->
            <div v-show="isTab" class="flexLayout">
                <div class="typeContainer flexItem clearfix color999 f16">
                    <div class="typeItem" :class="{active:tab.active===tabItem}"
                         v-for="tabItem in tab.list" :key="tabItem"
                         @click="tab.active = tabItem"
                    >{{tabItem}}
                    </div>
                </div>
<!--                <div class="dropDown alignR" style="width: 30px;">-->
<!--                    <img class="icon size20" src="components/search/filter_icon.svg"-->
<!--                       style="margin-top: 7px;"-->
<!--                       @click="sortControl.visible=!sortControl.visible"/>-->
<!--                </div>-->
            </div>

            <!-- 导航栏部分 -->
            <div class="sortControl white_bg" style="padding-top: 12px;" v-show="sortControl.visible">
                <div class="inner paddingH16 font14r color999">
                    <label class="block item clearfix" :class="{active:optionItem.key === sortControl.value}"
                        v-for="optionItem in sortControl.options"
                        :key="optionItem.key" @click="selectSortItem(optionItem)"
                    >
                        <span class="floatL">{{optionItem.title}}</span>
                        <input type="radio" class="fr modernCheckbox" :value="optionItem.key"
                            v-model="sortControl.value"/>
                    </label>
                </div>
            </div>
        </div>

        <!-- <div style="margin-top:16px;" class="detail_page"></div> -->

        <div class="detail_page paddingH16" v-show="submitTimes === 0">

            <!-- <div style="height: 42px;"></div> -->

            <div class="" style="margin-top: 14px;">
                <adModule :type="adTypeEnum.SEARCH_PAGE.code" version="4"/>
            </div>

            <div class="font18r fWeight600 grey20" style="margin-bottom: 16px;margin-top:20px">热门搜索</div>

            <div class="keywordsList">
                <span class="textLabel" v-for="kItem in hotKeyWordList" :key="kItem"
                    @click="selectKeyword(kItem)">{{kItem}}</span>
            </div>

            <div class="clearfix" v-show="myKeyWordList.length" style="margin-top: 26px;">
                <div class="floatL font18r fWeight600 grey20" style="margin-bottom: 18px;">搜索历史</div>
                <div class="floatR f12 grey70" @click="cleanHistory()">清空</div>
            </div>

            <div class="keywordsList">
                <span class="textLabel" v-for="kItem in myKeyWordList" :key="kItem"
                    @click="selectKeyword(kItem)">{{kItem}}</span>
            </div>

<!--            <div class="hiddenScrollbar" style="padding-bottom: 20px; overflow: auto">-->
<!--                <div class="clearfix" :style="'width:' + ((243+18)*3 - 18) + 'px' ">-->
<!--                    <div class="fl" style="width: 243px; margin-right: 18px;">-->
<!--                        <hot-search-module type="course_vod" :bizType="bizTypeEnum.VOD.code"/>-->
<!--                    </div>-->
<!--                    <div class="fl" style="width: 243px; margin-right: 18px;">-->
<!--                        <hot-search-module type="datum" :bizType="bizTypeEnum.DATUM.code"/>-->
<!--                    </div>-->
<!--                    <div class="fl" style="width: 243px;">-->
<!--                        <hot-search-module type="atlas" :bizType="bizTypeEnum.ATLAS.code"/>-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->

            <div style="height: 20px;"></div>

<!--            <horizontalLayoutContainer :width="243" :cellPadding="18">-->
<!--                <horizontalLayoutItem>-->
<!--                    <hot-search-module type="course_vod" :bizType="bizTypeEnum.VOD.code"/>-->
<!--                </horizontalLayoutItem>-->
<!--                <horizontalLayoutItem>-->
<!--                    <hot-search-module type="datum" :bizType="bizTypeEnum.DATUM.code"/>-->
<!--                </horizontalLayoutItem>-->
<!--                <horizontalLayoutItem>-->
<!--                    <hot-search-module type="atlas" :bizType="bizTypeEnum.ATLAS.code"/>-->
<!--                </horizontalLayoutItem>-->
<!--            </horizontalLayoutContainer>-->

            <hot-search-module />

        </div>

        <div class="detail_page" v-show="submitTimes > 0">

            <!-- 资料内容 -->
            <div style="margin-top:16px"  v-show="tab.active==='资料'">
                <datumList ref="datumList"/>
            </div>

            <!-- 课程内容 -->
            <div style="margin-top:16px" v-show="tab.active==='课程'">
                <courseList ref="courseList"/>
            </div>

            <!-- 音频部分 -->
            <div style="margin-top:16px"  v-show="tab.active==='音频'">
                <voiceList ref="voiceList"/>
            </div>

            <!-- 环创部分 -->
            <div v-show="tab.active==='环创'">
                <atlasList ref="atlasList"/>
            </div>
        </div>

        <div class="layer mask" v-show="sortControl.visible" @click="sortControl.visible=false;"></div>
    </div>
</template>
<script>
// part
import shixunPagePart from "@comp/shixunApp/shixunPagePart";

// api
import searchApi        from './searchApi';
import requestManager   from '@comp/platformApi/requestManager';

// data
import adTypeEnum   from '@/components/ad/adTypeEnum';
import bizTypeEnum from '@data/bizTypeEnum';

// modules
import searchInputbox   from "./searchInputbox";
import courseList from "./courseList.vue";
import datumList from "./datumList.vue";
import voiceList from "./voiceList.vue";
import atlasList from "./atlasList.vue";
import hotSearchModule from './hotSearchModule';

import adModule from '@comp/ad/oneImageAdModule'
import {horizontalLayoutContainer, horizontalLayoutItem} from '@comp/horizontalLayoutContainer'

// util
import objectHelper from '@util/objectHelper';
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';

const config = {
    keywordLimit : 10
};

export default {
    extends : shixunPagePart,
    components: {
        searchInputbox,
        adModule, hotSearchModule,
        courseList, datumList, voiceList, atlasList,
        horizontalLayoutContainer, horizontalLayoutItem
    },
    data() {
        return {

            pageKey: 'search',
            title : '搜索',

            adTypeEnum : adTypeEnum,
            bizTypeEnum : bizTypeEnum,

            //tab栏状态
            isTab:false,


            tab : {
                list : [
                    '资料',
                    // '课程',
                    // '音频',
                    // '环创'
                ],
                active : '资料'
            },
            current: 0,
            navigationSortItem: 0,
            NavigationSwitch: false,
            cutCheckout: false,
            submitTimes : 0,

            // 字典关键字
            classKeyWord: 0,
            videoKeyWord: 0,
            loopKeyWord: 0,
            sortControl: {
                visible : false,
                options : [
                    {
                        type: false,
                        key : 'DEFAULT',
                        title: "综合排序",
                    },
                    {
                        type: false,
                        key : 'CREATE_TIME',
                        title: "按最新日期",
                    },
                    {
                        type: false,
                        key : 'PRICE',
                        title: "按价格(从低到高)",
                    },
                    {
                        type: false,
                        key : 'AUDIENCE_COUNT',
                        title: "按在学人数(从多到少)",
                    },
                ],
                active : null,
                value : ''
            },
            hotKeyWordList : [],
            myKeyWordList : [],

            suggestionList : []
        };
    },
    methods: {
        back(){
            appHelper.back(this)
        },

        loadKeywords() {
            let options = objectHelper.clone(searchApi.keywords);
            options.data = {
                limit : config.keywordLimit
            };

            const me = this;
            requestManager.request(options, (error, result) => {
                if (error) {
                    consoleHelper.logError(error);
                    return '';
                }

                me.hotKeyWordList = result.data.hotKeyWord || [];
                me.myKeyWordList = result.data.myKeyWord || [];
            });
        },

        onChangeKeywords() {
            this.search();
        },

        selectKeyword(keyword) {
            this.$refs.searchInputbox.value = keyword;
            this.search();
        },

        search () {
            //点击搜索改变状态
            this.isTab = true;

            this.submitTimes++;

            let value = this.$refs.searchInputbox.value;

            this.$refs.courseList.filters.title = value;
            this.$refs.courseList.reloadDataList();

            this.$refs.datumList.filters.title = value;
            this.$refs.datumList.reloadDataList();

            this.$refs.voiceList.filters.title = value;
            this.$refs.voiceList.reloadDataList();

            this.$refs.atlasList.filters.title = value;
            this.$refs.atlasList.reloadDataList();
        },
        selectSortItem(item) {
            this.$refs.courseList.apiConfig.list.params.sortType = item.key;
            this.$refs.courseList.reloadDataList();

            this.$refs.datumList.apiConfig.list.params.sortType = item.key;
            this.$refs.datumList.reloadDataList();

            this.$refs.voiceList.apiConfig.list.params.sortType = item.key;
            this.$refs.voiceList.reloadDataList();

            this.$refs.atlasList.apiConfig.list.params.sortType = item.key;
            this.$refs.atlasList.reloadDataList();
        },

        cleanHistory() {
            const me = this;
            requestManager.request(searchApi.cleanHistory, () => {
                me.myKeyWordList = [];
            });
        },

        onSuggest(suggestionList) {

            this.suggestionList = suggestionList;
            // if (1)
            // {
            //     this.suggestionList = [
            //         'asdf', 'wegw', '4h34h34'
            //     ]
            // }
        },

        onSelectSuggestion(keywords)
        {
            this.$refs.searchInputbox.setValue(keywords);
            this.reloadDataList();
            this.suggestionList = [];
        }

    },
    mounted() {
        appHelper.setTitle('搜索 - 师讯平台');
        this.loadKeywords();
    },
};
</script>
<style lang="scss" scoped>

.keywordsList .textLabel{
    font-size: 75%;
    line-height: 2.0835em;
    height: 2.0835em;
    padding: 0 12px;
    color: hsla(0, 0%, 60%, 1);
    background-color: hsla(0, 0%, 96%, 1);

    border-radius: 14px;
    margin-right: 12px;
    margin-bottom: 14px;
}

.searchContent {

    .typeContainer {
        .typeItem {
            margin-right: 24px;
            float: left;
            padding: 10px 0;
            position: relative;

            &.active {
                color: #333;
                font-weight: bold;
                font-size: 18px;
                &:before {
                    display: block;
                    content : '';
                    width: 19px;
                    height: 6px;
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    margin-left: -10px;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAMCAYAAAAOCs/+AAAB3klEQVRIS83UPWhTYRTG8f9zb4t1cHGyi/lUBCEOiqMgdqhDQQUhSTcHW3DQRdBBTAVB0EGQKJ26GFNRHERR3Fo3J8HBwSZNFbv4UVorqPHeI7k0bRKSxtAofeFO7/n43cPLEZv0qOqyydhRjP2Y91Lp0tT/8tr9yCE89w6wC9lDvi6d1plPywHM8rFLoCsBxsxDZJUqnP3XOLsXG0Q8Am1d6+VnlCqOrcDiX4DtdRBjGqc8quTc224DbZxetsUuAxeQ3Ib6T5SaGapO7B0o3gTwC3Eb+3ldqQ/z3QBaLjqMo0yLfiAbVbIwvgKLHsGcZ4je5s3NwzQJv+8qXXreKdDy4TDmDoHOIaIt8+VfU7J4sXK/9vjz0QOYHiP1r9vYKCN7gdkr5MxivMe8Uk1OCLkCSyDtw+wgsBfJafNDY0rNZKoxq7Dg3U+Ed9DnZkEnOp3KBuIL+N4pDc9O19aog62ujlzoMOq5iZTYQMP1U43v4N9i4dvVynpoDG4KC6aXwSEeGcBxziMNdA9oC0CWJbuhkeJiq7otYbUJlouEQMeQBoOv8/MR7Cm+PWC5OKURyu1K/BWsDnkSl+M790BPAjm7MetHbMHoAyrrxQfNgb+Izxv047XS85/bQRrv/wCJ2Z0NYZairQAAAABJRU5ErkJggg==);

                    border-radius: 2px;
                }
            }
        }
    }

    // 导航栏部分
    .sortControl {
        width: 100%;
        position: absolute;
        left: 0;
        z-index: 5;

        .item {
            margin-bottom: 12px;

            &.active {
                color: #333;
            }
        }
    }
}


</style>
